module.exports = __webpack_public_path__ + "img/2.9b2b1e7b.png";